import {
  Box,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
  Typography
} from '@mui/material';
import { useTheme } from '@mui/material/styles'

const SwitchDashboard = ({ description, isChecked, onChangeSwitch, isDisabled }) => {
  const theme = useTheme()

  return <FormControlLabel
    label={
      <Typography
        sx={{ color: theme.palette.black.main }}
        variant="caption"
      >
        {description}
      </Typography>
    }
    control={
      <Switch
        checked={isChecked}
        size="small"
        onChange={onChangeSwitch}
        disabled={isDisabled}
      ></Switch>
    }
  ></FormControlLabel>
}

export default SwitchDashboard;